import React, { Fragment, useState } from 'react'
import ReactPlayer from 'react-player/lazy'
import ImageModal from './ImageModal'

const FullTemplateOneTwo = ({ data }) => {
    const { 
        image,
        image1,
        isComparisonChart,
        image2,
        lowerLeftContent,
        lowerLeftContentBlue,
        upperRightContent,
        lowerRightContentBlue,
        lowerRightContent1,
        lowerRightContent2,
        embeddedVideo
     } = data

    const [showImage, setShowImage] = useState(false);
    const [photo, setPhoto] = useState();

    const handleShowImageModal = (image) => {
        setShowImage(!showImage);
        setPhoto(image)
    }

    return (
        <Fragment>
            <section className="full-template-one two-version">
                <div className="left col">
                    {image1 && (
                        <>
                            {isComparisonChart ? (
                                <a onClick={(e) => handleShowImageModal(image1)}>
                                    <div className="image-wrapper">
                                        <img 
                                            src={image1?.localFile?.childImageSharp?.fluid?.src}
                                        />
                                    </div>
                                </a>
                            ) : (
                                <div className="image-wrapper">
                                    <img 
                                        src={image1?.localFile?.childImageSharp?.fluid.src}
                                    />
                                </div>
                            )}
                        </>    
                    )}
                </div>
                <div className="right col">
                    <div className="upper-right-content">
                        <div className="title">
                            {upperRightContent.icon && (
                                <div className="icon-wrapper">
                                    <img 
                                        src={upperRightContent.icon?.localFile?.childImageSharp?.fixed.src}
                                    />
                                </div>
                            )}
                            {upperRightContent.title && (
                                <h5>{upperRightContent.title}</h5>
                            )}
                        </div>
                        {upperRightContent.content && (
                            <div dangerouslySetInnerHTML={{ __html: upperRightContent.content }}></div>
                        )}
                        {upperRightContent.button && (
                            <a className="btn button-solid" href={upperRightContent.button.url}>{upperRightContent.button.title}</a>
                        )}
                    </div>
                    {lowerRightContentBlue.content && (
                        <div className="lower-right-content-blue">
                            <div className="title">
                                {lowerRightContentBlue.icon && (
                                    <div className="icon-wrapper">
                                        <img 
                                            src={lowerRightContentBlue.icon?.localFile?.childImageSharp?.fixed.src}
                                        />
                                    </div>
                                )}
                                {lowerRightContentBlue.title && (
                                    <h5>{lowerRightContentBlue.title}</h5>
                                )}
                            </div>
                            {lowerRightContentBlue.content && (
                                <div dangerouslySetInnerHTML={{ __html: lowerRightContentBlue.content }}></div>
                            )}
                        </div>
                    )}
                </div>
                <ImageModal showImage={showImage} hide={handleShowImageModal} photo={image1} />
            </section>
            {embeddedVideo && (
                <section className="media-section">
                    <div className="media-wrapper">
                         <ReactPlayer 
                            url={embeddedVideo}
                            className='react-player'
                            width='100%'
                            height='100%'
                            controls={true}
                        />
                    </div>
                </section>
            )}
        </Fragment>
    )
}

export default FullTemplateOneTwo
